import { LeakIcon } from './LeakIcon';

/**
 * author: Google
 * id D648ECFA-B185-4041-8B54-6D1C125CD08E
 * name leak
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/leak.svg
 * tags
 */
export const ProximitySensorIcon = LeakIcon;
export default ProximitySensorIcon